'use client';

import { swal } from '@/lib/sweetalert';
import { useEffect, useRef } from 'react';

/**
 * エラーメッセージをモーダルで表示するコンポーネント
 *
 * くじ確認画面のサーバー側処理でくじを引けないと判定されたとき、理由をクエリパラメータ
 * （errorMsg）に載せてくじ詳細画面へ戻している。それを受け取って一度だけ表示する。
 *
 * メッセージは利用者が組み立てられるため、html ではなく text で描画する swal.messageText を使う。
 * 表示後はクエリパラメータを取り除き、再読み込みや履歴の戻る操作で再表示されないようにする。
 */
function ShowErrorMessage({ message }: { message: string }) {
  const shownRef = useRef(false);

  useEffect(() => {
    // 既に表示済みの場合は何もしない
    if (shownRef.current || !message) return;
    shownRef.current = true;

    // URLからクエリパラメータを削除（再読み込み・戻る操作での再表示を防ぐため）
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('errorMsg');
    window.history.replaceState({}, '', newUrl.toString());

    swal.messageText({ message });
  }, [message]);

  return null; // このコンポーネントは何も描画しない
}

export default ShowErrorMessage;
